const Config = {
  getCdnUrl: function () {
    try {
      if (process.env.REACT_APP_CDN_URL) {
        return process.env.REACT_APP_CDN_URL;
      }
    } catch (e) {}
    return "";
  },
};

export default Config;
